import { Weapon, type WeaponConfig } from './Weapon';

const GRENADE_LAUNCHER_CONFIG: WeaponConfig = {
  id: 'grenade_launcher',
  name: 'Гранатомёт',
  // economy W12, calibrated to budget=30+10L
  price: 6500,
  fireRateMs: 1000,
  bulletsPerShot: 1,
  spreadDeg: 0,
  soundKey: 'pistol_shot',
  soundVolume: 0.6,
  shakeShoot: { intensity: 0.005, duration: 80 },
  magazineSize: 4,
  reloadTimeMs: 3000,
  fireMode: 'single',
  isGrenade: true,
  explosionRadius: 115,
  flightDurationMs: 900,
  rangePx: 495,
  arcHeight: 80,
  recoilForce: 4,
  damageCenter: 8,
  damageEdge: 2,
};

export function createGrenadeLauncher(): Weapon {
  return new Weapon(GRENADE_LAUNCHER_CONFIG);
}
